<template>
	<svg class="icon-download" width="17" height="24" viewBox="0 0 17 24" fill="none"
		 xmlns="http://www.w3.org/2000/svg">
		<path d="M13.8194 11.2448L7.90972 17.7057L2 11.2448" stroke-width="2" stroke-miterlimit="10"
			  stroke-linecap="round"/>
		<path d="M7.90977 17.7143L7.90977 1" stroke-width="2" stroke-miterlimit="10"
			  stroke-linecap="round"/>
		<path d="M15.2857 23H1" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/>
	</svg>
</template>

<script setup lang="ts">

</script>

<style lang="scss" >
.icon-download {
  stroke: var(--default-button-text-color);
  width: 16px;
}
</style>